module.exports = __webpack_public_path__ + "static/media/richang1.87019ffd.jpg";